import React, { useEffect, useState } from "react";
import { Segment, Select, Input } from "semantic-ui-react";

function prefix(subscription) {
  if (!subscription) {
    return "us_national";
  }
  const { state, name, category } = subscription;
  if (category.toUpperCase() === "STATE") {
    return state.toLowerCase() + "_state";
  }

  const state2 = state.toLowerCase();
  const name2 = name.toLowerCase().replace(" ", "-");
  return `${state2}_${name2}`;
}

function asOption(w) {
  // TODO be a little more clever here
  // e.g. text count be state, name ?
  return { key: w, value: w, text: w };
}

function availableOptions(subs) {
  const regions = [...new Set(subs.map(prefix))].map(asOption);
  const collections = [...new Set(subs.map((r) => r.collection))].map(asOption);
  const columnsets = [...new Set(subs.map((r) => r.column_set))].map(asOption);
  return { regions, collections, columnsets };
}

function DashboardOptions({ userInfo, mobile, setFiles }) {
  // if this is undefined that's going to be a problem!
  // TODO assert/test every user has at least one subscription?
  const firstSubscription = userInfo.subscriptions[0];

  const [options] = useState(() => availableOptions(userInfo.subscriptions));

  const [region, setRegion] = useState(() => prefix(firstSubscription));
  const [collection, setCollection] = useState(
    () => firstSubscription["collection"] || "listings"
  );
  const [columnset, setColumnset] = useState(
    () => firstSubscription["column_set"] || "classic"
  );
  const [limit, setLimit] = useState(52);

  const [warning, setWarning] = useState(<></>);

  const historic_only = userInfo.account.historic_only;
  // TODO for a one time account setLimit to ALL
  const historic_only_warning = historic_only ? (
    <div className="ui icon info message">
      <i className="warning sign icon"></i>
      <div className="content">
        <div className="header">Historic only account</div>
        <p>Your Altos Intel account isn't receiving the latest data files.</p>
        <p>
          Email{" "}
          <a href="mailto:sales@altosresearch.com">sales@altosresearch.com</a>{" "}
          to get our most recent data.
        </p>
      </div>
    </div>
  ) : (
    <></>
  );

  const trial_until = userInfo.account.trial_until;
  const trial_warning = trial_until ? (
    <div className="ui icon error message">
      <i className="wait icon"></i>
      <div className="content">
        <div className="header">Trial account</div>
        <p>Your Altos Intel trial will end on {trial_until}.</p>
        <p>
          Email{" "}
          <a href="mailto:sales@altosresearch.com">sales@altosresearch.com</a>{" "}
          to extend.
        </p>
      </div>
    </div>
  ) : (
    <></>
  );

  // search
  useEffect(() => {
    const qs = new URLSearchParams({
      region,
      type: collection,
      limit,
      columnset,
    });

    setWarning(
      <div className="ui icon info message">
        <i className="notched circle loading icon"></i>
        <div className="content">
          <div className="header">One moment</div>
          <p>We're fetching that files list for you.</p>
        </div>
      </div>
    );

    fetch(`/api/list?${qs}`).then((resp) => {
      if (resp.status === 200) {
        resp.json().then((files) => {
          setFiles(files);
          setWarning(<></>);
        });
      } else {
        const similar = userInfo.subscriptions
          .filter((s) => prefix(s) === region)
          .map((s) => `${s.collection} ${s.column_set}`)
          .join(", ");
        setWarning(
          <div className="ui negative message">
            <div className="header">Error listing files</div>
            <p>You're not subscribed to this data set.</p>
            <p>
              For {region} the following are available: {similar}.
            </p>
          </div>
        );
      }
    });
  }, [userInfo, region, collection, columnset, limit, setFiles]);

  return (
    <>
      {historic_only_warning}
      {trial_warning}
      <Segment vertical className="ui container">
        <Input action>
          <Select
            options={options.regions}
            defaultValue={region}
            onChange={(e, { value }) => setRegion(value)}
          />

          <Select
            options={options.collections}
            defaultValue={collection}
            onChange={(e, { value }) => setCollection(value)}
          />

          <Select
            options={options.columnsets}
            defaultValue={columnset}
            onChange={(e, { value }) => setColumnset(value)}
          />
          <Select
            options={[
              { key: 1, value: 1, text: "Week" },
              { key: 5, value: 5, text: "Month" },
              { key: 52, value: 52, text: "Year" },
              { key: 999, value: 999, text: "ALL" },
            ]}
            defaultValue={limit}
            onChange={(e, { value }) => setLimit(value)}
          />
          {/* <Button onClick={search}>Search</Button> */}
        </Input>
      </Segment>

      {warning}
    </>
  );
}

export default DashboardOptions;
